import { useNavigate } from "react-router-dom";
import { useRcmImport } from "../../../contexts/rcmImportContext";
import { RcmUploadCard } from "./components/RcmUploadCard";

export const UploadRcmPage = () => {
  const navigate = useNavigate();
  const { clear } = useRcmImport();

  return (
    <div className="w-full p-10 max-w-[900px] mx-auto">
      <div className="mb-6">
        <div className="text-sm text-stone-500 mb-1">Upload RCM Document</div>
        <h1 className="text-3xl font-bold tracking-tight">
          Upload RCM Document
        </h1>
        <div className="text-stone-600 mt-1">
          Supports Excel (.xlsx, .xls) files
        </div>
      </div>

      <RcmUploadCard
        onCancel={() => {
          clear();
          navigate("/audit/rcm");
        }}
      />
    </div>
  );
};

export default UploadRcmPage;
